import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { AppPages } from '../../common/routing/app-navigator';
import { useIsLoadingConnectors } from '../../connectors/store-actions/connectors-store-actions';
import { scanAll, useIsScanning } from '../actions/scan-actions';
import ScanButton from '../components/ScanButton';
import ScanStore from '../store/scan-store';
import { openExceedScanLimitModal } from '../store/scan-store-actions';

const FullScanButton = () => {
  const isLoadingConnectors = useIsLoadingConnectors();
  const isScanning = useIsScanning();
  const { isExceedScanLimit, isScanAllDisabled } = useSnapshot(ScanStore);

  const navigate = useNavigate();

  const handleFullScan = useCallback(() => {
    if (isExceedScanLimit) {
      openExceedScanLimitModal();
      return;
    }
    scanAll(false, true);
    navigate(AppPages.Dashboard);
  }, [navigate, isExceedScanLimit]);

  const getTitle = useCallback(() => {
    if (isLoadingConnectors) return 'Loading..';
    if (isScanning) return 'Scan in progress.';
    if (isScanAllDisabled)
      return 'Ensure a valid token is available in the connectors screen.';
    return 'Will run a full scan using all configured connectors';
  }, [isLoadingConnectors, isScanning, isScanAllDisabled]);

  return (
    <ScanButton
      value={!isLoadingConnectors && (isScanning ? 'Scanning...' : 'Full Scan')}
      tooltip={getTitle()}
      disabled={isScanAllDisabled || isLoadingConnectors}
      onClick={handleFullScan}
      variant={isScanning ? 'outlined' : 'contained'}
      withProgress={isLoadingConnectors}
    />
  );
};

export default FullScanButton;
